module.exports = __webpack_public_path__ + "static/media/job-template-banner.e00adf7b.png";